import { useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createInstitutionSettingsSubMenu } from "src/routing/navigation";

const InstitutionSettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(() => {
        return createInstitutionSettingsSubMenu();
    }, []);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default InstitutionSettingsSubMenu;
